import { Box, Card, Icon, Link, Text } from '@nimbus-ds/components';
import { IconBox } from 'commons/components';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import { DiscountOption } from './types';

export function DiscountOptionCard({
  title,
  description,
  onClick,
  icon,
}: Readonly<DiscountOption>): JSX.Element {
  const t = useTranslationMarketing('moreDiscounts');
  const IconComponent = icon;

  return (
    <Card padding="none">
      <Card.Body>
        <Box
          display="grid"
          gridTemplateColumns={{ xs: '20fr 60fr 20fr', md: '14fr 72fr 14fr' }}
          alignItems="center"
          paddingTop="3-5"
          paddingBottom="3-5"
          paddingLeft="1"
          paddingRight="1"
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            <IconBox
              color="primary-interactive"
              backgroundColor="primary-surface"
              height="38px"
              width="38px"
              minWidth="38px"
            >
              <Icon
                color="primary-textLow"
                source={<IconComponent size={26} />}
              />
            </IconBox>
          </Box>

          <Box display="flex" flexDirection="column" justifyContent="center">
            <Text fontSize="base" color="neutral-textHigh">
              {title}
            </Text>
            <Text>{description}</Text>
          </Box>

          <Box display="flex" justifyContent="center" alignItems="center">
            <Link
              onClick={onClick}
              appearance="primary"
              textDecoration="none"
              fontSize="highlight"
            >
              {t('ctas.create')}
            </Link>
          </Box>
        </Box>
      </Card.Body>
    </Card>
  );
}
